export const formatearFecha = (fecha) => {
    if (!fecha) return null;
    const date = new Date(fecha);
    return date.toISOString().split("T")[0]; // "YYYY-MM-DD"
};
